import { GithubIssueItem } from '@/pages/MainPlatform/Company/List/typings';
import { getPlatformListToUid } from '@/services/company/CompanyController';
import { PlatformEnum } from '@/settings/enum';
import { ProList } from '@ant-design/pro-components';
import { useRequest } from 'ahooks';
import { Button, Drawer, Input, Space, Tag, Typography } from 'antd';
import React, { cloneElement, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default (props: any) => {
  const { children, showDrawer } = props;
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);

  const fetchCompanyListToUid = useRequest(getPlatformListToUid, {
    manual: true,
  });
  const onClose = () => {
    setOpen(false);
  };

  //  进入公司
  function enterCompany(data: any) {
    dispatch({ type: `${PlatformEnum.NAME}/setCompanyInfo`, payload: data });
    window.location.href = '/';
  }

  // 返回平台
  function enterMainPlatform() {
    dispatch({ type: `${PlatformEnum.NAME}/removePlatformAll` });
    window.location.href = '/';
  }

  function openDrawer() {
    setOpen(true);
  }

  return (
    <React.Suspense fallback={'loading'}>
      {cloneElement(children, { onClick: openDrawer })}
      <Drawer
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>快速进入公司入口</div>
            <Button onClick={enterMainPlatform}>返回平台</Button>
          </div>
        }
        width={550}
        closable={false}
        placement="left"
        onClose={onClose}
        open={open}
      >
        <ProList<GithubIssueItem>
          search={{}}
          rowKey="name"
          // loading={fetchCompanyListToUid.loading}
          request={async (params) => {
            const { current, ...values } = params;
            return await fetchCompanyListToUid.runAsync({
              ...values,
              page: current,
              platform_id: 2,
            });
          }}
          pagination={{
            pageSize: 10,
            size: 'small',
          }}
          showActions="hover"
          form={{
            layout: 'inline', // 使用 'vertical' 布局将 label 放在上方
            labelCol: { span: 0 }, // 自定义 label 的宽度
            size: 'middle',
            className: 'drawer-company-list-search',
          }}
          metas={{
            title: {
              dataIndex: 'company',
              title: '公司名称',
              render: (_, row) => {
                return (
                  <Typography.Text
                    style={{
                      width: '200px',
                      cursor: 'pointer',
                      color: '#1890ff'
                    }}
                    ellipsis={{ tooltip: _ }}
                    onClick={() => enterCompany(row)}
                  >
                    {_}
                  </Typography.Text>
                );
              },
              renderFormItem: () => {
                return (
                  <Input
                    // 自定义配置
                    placeholder="请输入公司名称"
                  />
                );
              },
            },
            avatar: {
              dataIndex: 'logoBase64',
              search: false,
            },
            description: {
              dataIndex: 'address',
              search: false,
              render: (text: React.ReactNode) => {
                return (
                  <Typography.Text type={'secondary'} ellipsis={{ tooltip: text }}>
                    {text}
                  </Typography.Text>
                );
              },
            },
            subTitle: {
              dataIndex: 'legalPerson',
              render: (_, row) => {
                return (
                  <Space size={0}>
                    <Tag color="blue">{row.legalPerson}</Tag>
                    <Tag>{row.mobile}</Tag>
                  </Space>
                );
              },
              search: false,
            },
            actions: {
              render: (text, row) => [
                <a onClick={() => enterCompany(row)} target="_blank" rel="noopener noreferrer" key="view" style={{ marginTop: '15px' }}>
                  进入公司
                </a>,
              ],
              search: false,
            },
          }}
        />
      </Drawer>
    </React.Suspense>
  );
};
